import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Button, Stack } from "@mui/material";
import Select from "react-select";
import { axiosInstance } from "../../utils/networking";
import ThriveTitle from "../common/ThriveTitle";
import { UserType } from "../../interfaces";

const ReassignClient = (props: any) => {
  const navigate = useNavigate();

  const [clientList, setClientList] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState<{
    value: any;
    label: any;
  }>({
    value: props.currUser._id,
    label: props.currUser.firstName + " " + props.currUser.lastName,
  });

  useEffect(() => {
    axiosInstance.get(`/user/allUsers`).then((res) => {
      if (res.status === 200) {
        const users = res.data.users as UserType[];
        const userNames = users.map((user: any) => {
          return {
            label: user.firstName + " " + user.lastName,
            id: user._id,
          };
        });
        setClientList(
          userNames.sort((a, b) =>
            a.label > b.label ? 1 : b.label > a.label ? -1 : 0
          )
        );
      } else {
        console.log("API Error at getting survey result");
      }
    });
  }, []);

  const handleSelectChange = (selectedClient: any) => {
    setSelectedValue(selectedClient);
  };

  const handleSubmit = () => {
    axiosInstance
      .post(`/cases/reassignClient`, {
        caseId: props.caseId,
        userId: selectedValue.value,
      })
      .then((res) => {
        props.setReassignClientOpen(false);
        navigate("/dashboard");
      });
  };

  return (
    <>
      <ThriveTitle
        title={"REASSIGN CLIENT"}
        setOpen={props.setReassignClientOpen}
      />
      <div className="w-full h-full flex flex-col items-center px-4 sm:px-0">
        <div className="mt-[20%] w-full max-w-[400px]">
          <Select
            value={selectedValue}
            onChange={handleSelectChange}
            className="w-full max-w-[400px]"
            placeholder="Select the Client"
            options={clientList.map((client) => ({
              value: client.id,
              label: client.label,
            }))}
            styles={{
              control: (provided, state) => ({
                ...provided,
                height: "50px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#9D2362" : "white",
                color: state.isSelected ? "white" : "black",
                ":hover": {
                  backgroundColor: state.isSelected ? "#9D2362" : "#F3F4F6",
                },
              }),
            }}
          />
        </div>
        <div className="mt-3">
          <Button
            variant="contained"
            sx={{
              width: "200px",
              fontSize: "20px",
              backgroundColor: "#9E1F63FF",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};
export default ReassignClient;
